const FirebaseConfig = {
  apiKey: "AIzaSyBlrCvhQ317r5tBRCGt2uGcqkkYPW2MXC8",
  authDomain: "crypto-creed-a0c31.firebaseapp.com",
  projectId: "crypto-creed-a0c31",
  storageBucket: "crypto-creed-a0c31.appspot.com",
  messagingSenderId: "321016599730",
  appId: "1:321016599730:web:a9b972c017fd6554c725ab",
  measurementId: "G-TTGF1F9BVW"
};

export default FirebaseConfig;
